import React from "react";
import type { WizardQuestion } from "../../data/wizard";
type WizardOptionStepProps = {
  question: WizardQuestion;
  selected: string;
  onSelect: (value: string) => void;
  size?: "lg" | "md";
  error?: string;
};
export function WizardOptionStep({
  question,
  selected,
  onSelect,
  size = "lg",
  error
}: WizardOptionStepProps) {
  const headingId = `q-${question.key}`;
  return <div data-id="element-61" data-mp="3i2uy6na4r1a1">
      <h3 id={headingId} className={`font-display uppercase leading-[1.05] tracking-[-0.01em] text-cream ${size === "lg" ? "text-[24px] sm:text-[30px]" : "text-[20px] sm:text-[24px]"}`} data-id="element-62" data-mp="3i2l7exh9gq3a">
        {question.question}
      </h3>
      <div role="radiogroup" aria-labelledby={headingId} aria-describedby={error ? `${headingId}-error` : undefined} className={`overflow-hidden rounded-[3px] border ${error ? "border-red-400/60" : "border-lineStrong"} ${size === "lg" ? "mt-8" : "mt-5"}`} data-id="element-63" data-mp="3mu377i7jskmo">
        {question.options.map(option => {
        const active = selected === option;
        return <button key={option} type="button" role="radio" aria-checked={active} onClick={() => onSelect(option)} className={`flex w-full items-center gap-4 border-b border-line px-5 text-left transition-colors duration-200 ease-out last:border-b-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold ${size === "lg" ? "min-h-[56px] py-3 text-[16px] md:min-h-[60px] md:py-4 md:text-[17px]" : "min-h-[56px] py-3 text-[16px] md:min-h-[52px]"} ${active ? "bg-gold/[0.08] text-cream" : "text-cream/90 hover:bg-white/[0.04]"}`} data-id="element-64" data-mp="3lc1yx9dtif7p">
              <span className={`flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${active ? "border-gold" : "border-steel"}`} aria-hidden="true" data-id="element-65" data-mp="lzjbsb20inwb">
                <span className={`h-2 w-2 rounded-full bg-gold transition-opacity duration-150 ease-out ${active ? "opacity-100" : "opacity-0"}`} data-id="element-66" data-mp="2i2o2tpl7n25t" />
              </span>
              <span data-id="element-67" data-mp="35q5r3b59ni41">{option}</span>
            </button>;
      })}
      </div>
      {error && <p id={`${headingId}-error`} className="mt-1.5 text-[14px] text-red-300" data-id="element-68" data-mp="31pdeq913kx3j">
          {error}
        </p>}
    </div>;
}